import React, { useEffect, useState } from "react";
import { UrlApiEnvasado } from "../../../../services/apirest";

// PARA EL IDIOMA DEL CALENDARIO
import "dayjs/locale/es";

// -- Tabla
const tablaStyles = {
  width: "100%",
  borderCollapse: "collapse",
};

const thTdStyles = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "left",
};

const thTdStyles2 = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "left",
  backgroundColor: "#f2f2f2",
};

const thStyles = {
  backgroundColor: "#f2f2f2",
};

export default function ChartsOverviewDemo() {
  const [loading, setLoading] = useState(false);
  const [markers, setMarkers] = useState([]);

  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );

  // ----------------------------------------------------------------------------------

  const obtenerMarkers = () => {
    setLoading(true); // Indicar que se está obteniendo los datos

    fetch(
      UrlApiEnvasado +
        "/envasado/fac_reng/pesototalvendido/mayormenorpromedio/anio/" +
        selectedYear
      // 2024
    )
      .then((data) => data.json())
      .then((data) => {
        setMarkers(data);
        setLoading(false); // Indicar que se han cargado los datos
      });
  };

  useEffect(() => {
    obtenerMarkers();
  }, []);

  return (
    <>
      <div style={{ height: "100%", width: "100%" }}>
        <table style={tablaStyles}>
          <thead>
            <tr>
              <th style={{ ...thTdStyles, ...thStyles }}>Sucursal</th>
              <th style={{ ...thTdStyles, ...thStyles }}>Ventas (kg)</th>
            </tr>
          </thead>
          <tbody>
            {markers.map((sucursal, index) => (
              <>
                <tr key={index}>
                  <td style={thTdStyles}>{sucursal.sucursal_menor_ventas}</td>
                  <td style={thTdStyles}>{sucursal.menor_ventas_totales}</td>
                </tr>
                <tr>
                  <td style={thTdStyles}>{sucursal.sucursal_mayor_ventas}</td>
                  <td style={thTdStyles}>{sucursal.mayor_ventas_totales}</td>
                </tr>
                <tr>
                  <td
                    colSpan="2"
                    style={{ ...thTdStyles2, textAlign: "center" }}
                  >
                    <b>Promedio:</b> {sucursal.promedio_ventas_totales} kg
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
